import KeyValueTable from './KeyValueTable';

export default KeyValueTable;
